export const RTLLangs = ['ar', 'he', 'fa', 'sd', 'ps', 'ur', 'yi', 'ug'];
